/* eslint-disable prefer-template */
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@carvana/theme';
import { purchaseEditOrderRouteWhitelist } from '@carvana/purchase-utils';
import {
  CancelOrderModal,
  EditOrderModal
} from '@carvana/purchase-order-placed';
import {
  DashboardModalActions,
  Experiment,
  When
} from '@carvana/purchase-helpers';
import VehicleSnapshot from './components/vehicle-snapshot';
import NavTab from './components/navigation-tab';
import * as sc from './navigation-rail.styles';

const { OpenModal } = DashboardModalActions;

const NavigationRail = props => {
  const {
    isMobile,
    navigationConfiguration: { navItems, navSections, navRail },
    isInPurchaseHeaderBucket
  } = props;
  const [, , route] = window.location.pathname.split('/');
  const navigationItems = navItems?.filter(x => x.navigation);
  const showNavRail = !!navigationItems && navRail;

  if (isMobile && route !== 'dashboard') return null;

  const openCancelOrderModal = () =>
    OpenModal({
      headerText: 'CANCEL ORDER',
      ModalChildren: CancelOrderModal,
      modalProps: sc.Content
    });

  const openEditOrderModal = () =>
    OpenModal({
      headerText: 'EDIT ORDER',
      ModalChildren: EditOrderModal,
      modalProps: sc.Content
    });

  const showEditButton = isMobile
    ? true
    : purchaseEditOrderRouteWhitelist.includes(route);

  return (
    <ThemeProvider>
      {showNavRail && (
        <sc.Wrapper>
          <VehicleSnapshot
            isInPurchaseHeaderBucket={isInPurchaseHeaderBucket}
          />
          {navSections?.map(section => (
            <sc.Section key={section.id}>
              <sc.SectionHeader>
                <span>{section.header}</span>
                {section.header === 'Purchase Process' &&
                  section.status === 'Done' &&
                  showEditButton && (
                    <Experiment
                      defaultBucket="control"
                      name="pp-finalize-purchase-edit-button"
                    >
                      <When bucket="edit-order-doc-upload">
                        <sc.EditAction onClick={openEditOrderModal}>
                          <sc.EditOrderText>Edit</sc.EditOrderText>
                        </sc.EditAction>
                      </When>
                    </Experiment>
                  )}
                <sc.SectionStatusWrapper>
                  <sc.SectionStatusText>{section.status}</sc.SectionStatusText>
                </sc.SectionStatusWrapper>
              </sc.SectionHeader>
              {section.containsNavItems && (
                <sc.NavTabsWrapper>
                  {navItems?.map(navItem => (
                    <NavTab
                      isActive={`/${route}` === navItem.route}
                      key={navItem.id}
                      navItem={navItem}
                    />
                  ))}
                </sc.NavTabsWrapper>
              )}
            </sc.Section>
          ))}
          <sc.Section>
            <sc.CancelAction onClick={openCancelOrderModal}>
              <sc.CancelOrderText>
                Want to cancel your order?
              </sc.CancelOrderText>
            </sc.CancelAction>
          </sc.Section>
        </sc.Wrapper>
      )}
    </ThemeProvider>
  );
};

NavigationRail.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  navigationConfiguration: PropTypes.shape({})
};

NavigationRail.defaultProps = {
  navigationConfiguration: {}
};

export default NavigationRail;
